import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Import Images
import relatorios from "../../assets/imgs/onepage/relatorios.png"

class Process extends Component {
  state = {
    processes: [
      { title: "Painel de Controle Intuitivo" },
      { title: "Relatórios Detalhados" },
      { title: "Gráficos e Visualizações" },
    ],
  };
  render() {
    return (
      <React.Fragment>
        <Container className="mt-100 mt-60">
          <Row className="align-items-center">
            <Col lg="5" md="6">
              <img
                src={relatorios}
                data-aos="fade-up"
                data-aos-duration="1800"
                className="img-fluid"
                alt=""
              />
            </Col>

            <Col lg="7" md="6" className="mt-4 mt-sm-0 pt-2 pt-sm-0">
              <div className="section-title ms-lg-5">
                <h4
                  className="title mb-4"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  Tenha uma Visão Clara de Todos os Seus Fluxos de Caixa
                </h4>
                <p
                  className="text-muted"
                  data-aos="fade-up"
                  data-aos-duration="1400"
                >
                  Veja todas as informações financeiras relevantes em um só lugar. Nosso sistema apresenta dados em tempo real de forma clara e organizada, permitindo que você acompanhe o desempenho financeiro do seu negócio com facilidade.
                </p>
                <ul
                  className="list-unstyled feature-list mb-0 text-muted"
                  data-aos="fade-up"
                  data-aos-duration="1800"
                >
                  {this.state.processes.map((process, key) => (
                    <li key={key} className="mb-0">
                      <span className="text-primary h5 me-2">
                        <i className="uil uil-check-circle align-middle"></i>
                      </span>
                      {process.title}
                    </li>
                  ))}
                </ul>
                <div
                  className="mt-4"
                  data-aos="fade-up"
                  data-aos-duration="2200"
                >
                   {/*
                  <Link to="#" className="text-primary p-1 px-2 shadow rounded">
                    Read More <i className="uil uil-angle-right-b"></i>
                  </Link>
                  */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Process;
